// lib
import React from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { DEFAULT_SCROLL_OPTIONS, LABEL } from './constants';

// styles
const Anchor = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:link {
    text-decoration: none;
  }

  &:visited {
    text-decoration: none;
  }
`;

// def
interface IScrollToElementProps {
  children: React.ReactNode;
  targetId: string;
  options?: IScrollIntoViewOptions;
  onClick?: VoidFunction;
  className?: string;
}

type ScrollBehaviorType = 'auto' | 'smooth';
type AlignmentType = 'start' | 'nearest' | 'center' | 'end';

export interface IScrollIntoViewOptions {
  // defines transition animation
  behavior?: ScrollBehaviorType;
  // defines vertical alignment
  block?: AlignmentType;
  // defines horizontal alignment
  inline?: AlignmentType;
}

function ScrollToElement({
  children,
  targetId,
  options = DEFAULT_SCROLL_OPTIONS,
  onClick,
  className,
}: IScrollToElementProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView(options);
    }

    onClick && onClick();
  };

  return (
    <Anchor
      data-test="scrollToElementButton"
      href={`#${targetId}`}
      role="button"
      onClick={handleClick}
      aria-label={LABEL}
      className={className}
    >
      {children}
    </Anchor>
  );
}

export default ScrollToElement;
